export const getPricingOfAccountEmailFinderCampaign = {
  GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST: "GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST",
  GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS: "GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS",
  GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR: "GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR"
};

export const editPricingOfAccountEmailFinderCampaign = {
  EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST: "EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST",
  EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS: "EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS",
  EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR: "EDIT_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR"
};
